export default __webpack_public_path__ + "static/STATUTO_PIL_ART_SSD-ca12689625aa1db01ced41e8ff5fb43e.pdf";